import script from "./RestockTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./RestockTable.vue?vue&type=script&lang=ts&setup=true"

import "./RestockTable.vue?vue&type=style&index=0&id=40cf1262&lang=scss"
import "./RestockTable.vue?vue&type=style&index=1&id=40cf1262&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40cf1262"]])

export default __exports__